import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useTeamCache } from './cache'
import { type TeamAddInput, type TeamAddSuccess, type TeamData, type UnsavedTeam } from '@terros/common'

export function useAddTeam(): AddHookResponse<UnsavedTeam, TeamData> {
  const cache = useTeamCache()
  const mutation = useTantalimMutation<TeamAddInput, TeamAddSuccess>({ url: '/team/add' })

  async function add(team: UnsavedTeam): Promise<TeamData> {
    const output = await mutation.mutateAsync(team)
    cache.clearList()
    if (team.parentId) {
      cache.clearItem(team.parentId)
    }
    return output.team
  }

  return mutationAdd(mutation, add)
}
